import { render, staticRenderFns } from "./IDVerify.vue?vue&type=template&id=17abf35c&scoped=true&"
import script from "./IDVerify.vue?vue&type=script&lang=js&"
export * from "./IDVerify.vue?vue&type=script&lang=js&"
import style0 from "./IDVerify.vue?vue&type=style&index=0&id=17abf35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17abf35c",
  null
  
)

export default component.exports